export async function NutricionCreate(
  nutrResp,
  nutrFecha,
  nutrNumses,
  nutrMedio,
  nutrPeso,
  nutrTalla,

  nutrDondcomid,
  nutrQuiencomid,
  nutrEnccocRad,
  nutrEnccampRad,

  nutrPichoras,
  nutrComrap,
  nutrApet,
  nutrTrastdig,
  nutrTrastdigEsp,

  nutrAlimmalestRad,
  nutrAlimmalestEsp,
  nutrAlergalimRad,
  nutrAlergalimEsp,
  nutrPesotiempRad,
  nutrPesotiempEsp,
  nutrSuplalimRad,
  nutrSuplalimEsp,

  nutrDigest,
  nutrRetliqu,
  nutrHorarcom,
  nutrEvaldesay,
  nutrEvalman,
  nutrEvalcomid,
  nutrEvalmeri,
  nutrEvalcena,
  nutrEvallact,
  nutrEvalverd,
  nutrEvalfrit,
  nutrEvalcarn,
  nutrEvalfrut,
  nutrEvalsals,
  nutrEvalpesc,
  nutrEvallegu,
  nutrEvalcafte,
  nutrEvalhuev,
  nutrEvalcere,
  nutrEvaldulc,
  nutrEvalemb,
  nutrEvalagua,
  nutrEvalfsec,
  nutrEvalrefr,
  nutrObs,
  nutrEstado,
  tratamientoId,
  pacienteId
) {
  const formData = {
    title: `us-${pacienteId}-tr-${tratamientoId}-nutr-${nutrNumses}`,
    slug: `us-${pacienteId}-tr-${tratamientoId}-nutr-${nutrNumses}`,
    status: "publish",
    tratamiento: tratamientoId,
    paciente: pacienteId,
    meta: {
      nutrResp: nutrResp,
      metaFecha: nutrFecha,
      metaPaciente: pacienteId,
      nutrNumses: nutrNumses,
      nutrMedio: nutrMedio,
      nutrPeso: nutrPeso,
      nutrTalla: nutrTalla,

      nutrDondcomid: nutrDondcomid,
      nutrQuiencomid: nutrQuiencomid,
      nutrEnccocRad: nutrEnccocRad,
      nutrEnccampRad: nutrEnccampRad,

      nutrPichoras: nutrPichoras,
      nutrComrap: nutrComrap,
      nutrApet: nutrApet,
      nutrTrastdig: nutrTrastdig,
      nutrTrastdigEsp: nutrTrastdigEsp,
      nutrAlimmalestRad: nutrAlimmalestRad,
      nutrAlimmalestEsp: nutrAlimmalestEsp,
      nutrAlergalimRad: nutrAlergalimRad,
      nutrAlergalimEsp: nutrAlergalimEsp,
      nutrPesotiempRad: nutrPesotiempRad,
      nutrPesotiempEsp: nutrPesotiempEsp,
      nutrSuplalimRad: nutrSuplalimRad,
      nutrSuplalimEsp: nutrSuplalimEsp,

      nutrDigest: nutrDigest,
      nutrRetliqu: nutrRetliqu,
      nutrHorarcom: nutrHorarcom,
      nutrEvaldesay: nutrEvaldesay,
      nutrEvalman: nutrEvalman,
      nutrEvalcomid: nutrEvalcomid,
      nutrEvalmeri: nutrEvalmeri,
      nutrEvalcena: nutrEvalcena,
      nutrEvallact: nutrEvallact,
      nutrEvalverd: nutrEvalverd,
      nutrEvalfrit: nutrEvalfrit,
      nutrEvalcarn: nutrEvalcarn,
      nutrEvalfrut: nutrEvalfrut,
      nutrEvalsals: nutrEvalsals,
      nutrEvalpesc: nutrEvalpesc,
      nutrEvallegu: nutrEvallegu,
      nutrEvalcafte: nutrEvalcafte,
      nutrEvalhuev: nutrEvalhuev,
      nutrEvalcere: nutrEvalcere,
      nutrEvaldulc: nutrEvaldulc,
      nutrEvalemb: nutrEvalemb,
      nutrEvalagua: nutrEvalagua,
      nutrEvalfsec: nutrEvalfsec,
      nutrEvalrefr: nutrEvalrefr,
      nutrObs: nutrObs,
      nutrEstado: nutrEstado,
    },
  };

  const authToken = sessionStorage.getItem("token");

  try {
    const response = await fetch(
      "https://app.tavad.com/hce/wp-json/wp/v2/nutricion",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
